import { render } from "./EditAssessmentTaskModal.vue?vue&type=template&id=34220306&scoped=true"
import script from "./EditAssessmentTaskModal.vue?vue&type=script&lang=js"
export * from "./EditAssessmentTaskModal.vue?vue&type=script&lang=js"

import "./EditAssessmentTaskModal.vue?vue&type=style&index=0&id=34220306&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34220306"]])

export default __exports__